import { NotificationsPage } from '@features/notifications/components/NotificationsPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_shell/notifications')({ component: NotificationsPage });
